<template>
  <div
    class="chat-visa-page"
    :class="[options.size]"
    :style="{ background: options.background }"
  >
    <div class="page-scroll-box">
      <chat-scroll
        ref="chatScroll"
        :isFixedScrollBottom.sync="layout.isFixedScrollBottom"
        :allow-scroll-top="layout.isClickedHistory"
        @scroll-top="getChatList()"
      >
        <div
          v-if="!options.hidePageBody"
          class="page-body"
          :style="{ width: options.bodyWidth }"
        >
          <div
            v-if="layout.hasHistory && !layout.isClickedHistory"
            class="show-more"
          >
            <div class="more-text" :class="[options.size]" @click="loadHistory">
              更多历史会话
            </div>
          </div>
          <div class="chat-list">
            <chat-item
              v-for="(item, index) in chatList"
              :key="item.chatvisa_record_id"
              :chat-item="item"
              :options="options"
              :is-last="index === chatList.length - 1"
              :hide-chat-avatar="options.hideChatAvatar"
              @update="updateChatItemInfo($event, index)"
            ></chat-item>
          </div>
        </div>

        <slot name="page-body" :chat-list="chatList"></slot>
      </chat-scroll>
    </div>
    <div class="footer-box" :class="[options.size]">
      <div class="footer-body" :style="{ width: options.bodyWidth }">
        <div class="quick-handler" v-if="!options.hidePageFooterHandle">
          <div class="left-box">
            <slot name="footer-handle-left"></slot>
            <quick-cs-btn></quick-cs-btn>
          </div>
          <div class="right-box">
            <div
              class="back-bottom"
              v-if="!layout.isFixedScrollBottom"
              @click="goScrollBottom"
            >
              <div class="icon"></div>
            </div>
          </div>
        </div>
        <div
          class="question-input-box"
          :class="{ focus: layout.textareaFocus }"
        >
          <div
            class="login-mask"
            v-if="!layout.isLogin"
            @click="SHOW_LOGIN_BOX"
          ></div>
          <div class="question-input-body" :class="[options.size]">
            <form-question-textarea
              v-model="formInfo.questionInput"
              :focus.sync="layout.textareaFocus"
              @enter="onSend"
              :options="options"
            ></form-question-textarea>
            <div class="input-bottom">
              <div
                v-if="formInfo.questionInput"
                class="question-num"
                :class="{ 'is-red': questionInputTrimLength > 2000 }"
              >
                {{
                  questionInputTrimLength > 2000
                    ? 2000 - questionInputTrimLength
                    : questionInputTrimLength
                }}
              </div>
              <div class="handle-btn" :class="[options.size]">
                <button v-if="isGenerating" class="item-btn" @click="onStop">
                  <div class="icon stop"></div>
                </button>
                <button
                  v-else
                  class="item-btn"
                  :disabled="disabledSendBtn"
                  @click="onSend()"
                >
                  <div class="icon send"></div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!options.hidePageFooterTips" class="tips">
          内容由AI生成，无法确保真实准确，仅供参考；如有疑问，请随时联系专属签证专家。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from '../../../libs/http';
import FormQuestionTextarea from './form-question-textarea.vue';
import ChatItem from './chat-item.vue';
import ChatScroll from './chat-scroll.vue';
import User from '@/libs/user';
import { mapMutations } from 'vuex';
import QuickCsBtn from './quick-cs-btn.vue';
import GuideModule from './guide-module.vue';
import sensorsdata from 'sa-sdk-javascript';

export default {
  components: {
    FormQuestionTextarea,
    ChatItem,
    ChatScroll,
    QuickCsBtn,
    GuideModule,
  },
  props: {
    countryId: Number,
    hooks: {
      type: Object,
      default: () => ({}),
    },
    /**
     * hidePageBody: 隐藏body
     * hidePageFooterHandle：隐藏底部操作
     * hidePageFooterTips： 隐藏底部提示
     * bodyWidth：body的宽度
     * background： 背景色
     * hideChatAvatar: 隐藏聊天头像
     * size: 大小，small 代表小尺寸显示模式
     */
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      layout: {
        isLogin: User.isLogin(),
        isFixedScrollBottom: true, // 当前是否滚动条固定在底部
        hasHistory: false, // 是否有历史记录
        isClickedHistory: false, // 是否点击过更多历史会话
        loading: false, // 当前列表加载中
        loadedAll: false, // 当前是否加载完成所有列表了
        textareaFocus: false, // 当前文本域是否有焦点
      },
      formInfo: {
        questionInput: '',
      },
      // status 0:待生成 1:生成中 2:已完成 3:手动停止 4:生成失败
      chatList: [],
    };
  },
  computed: {
    questionInputTrimLength() {
      const text = this.formInfo.questionInput
        ? this.formInfo.questionInput.trim()
        : '';
      return text.length;
    },
    disabledSendBtn() {
      return (
        this.questionInputTrimLength <= 0 || this.questionInputTrimLength > 2000
      );
    },
    // 是否在生成中
    isGenerating() {
      return this.chatList.some(item => [0, 1].includes(item.status));
    },
  },
  beforeRouteEnter(to, from, next) {
    sensorsdata.track('qw_view', {
      source: !from.name ? '直接访问' : to.query.page_from,
    });
    next();
  },
  created() {
    if (User.isLogin()) {
      this.getChatList(true);
    }
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    async getChatList(isToday) {
      try {
        if (this.layout.loading || this.layout.loadedAll) return;
        this.layout.loading = true;
        const params = {};
        if (isToday) {
          params.is_today = 1;
        } else {
          // 否则说明是加载更多触发的
          params.top_chatvisa_record_id = this.chatList[0]
            ? this.chatList[0].chatvisa_record_id
            : undefined;
        }
        const res = await Http.post('/chatvisa_record_brief_query', params);

        this.chatList.unshift(...res.page_data);
        // 触发回调
        this.hooks.getChatList && this.hooks.getChatList(this.chatList);
        if (isToday) {
          if (res.total_count > res.page_data.length) {
            // 说明有历史记录
            this.layout.hasHistory = true;
          }
        } else {
          // 加载更多触发
          if (res.page_data.length < 10) {
            this.layout.loadedAll = true;
          }

          // 保持滚动条位置
          if (this.$refs.chatScroll) {
            this.$refs.chatScroll.keepScrollTopByLoadMore();
          }
        }

        this.layout.loading = false;
      } catch (error) {
        this.layout.loading = false;
      }
    },
    // 加载历史
    loadHistory() {
      sensorsdata.track('qw_history_click', this.options.sensorsData);
      this.layout.isClickedHistory = true;
      this.getChatList();
    },
    // 发送，questionText说明是快捷问题进来的
    async onSend(questionText) {
      if (this.isGenerating) return;
      if (!questionText && this.disabledSendBtn) return;

      if (!questionText) {
        sensorsdata.track('qw_message_sent', this.options.sensorsData);
      }

      const finnalQuestion = questionText || this.formInfo.questionInput.trim();

      const res = await Http.post('/chatvisa_record_submit', {
        question: finnalQuestion,
      });
      this.chatList.push({
        chatvisa_record_id: res.chatvisa_record_id,
        question_message: finnalQuestion,
        answer_message: '',
        status: 0, // 0:待生成 1:生成中 2:已完成 3:手动停止 4:生成失败
        review_status: 0,
      });
      this.formInfo.questionInput = '';

      // 触发回调
      this.hooks.onSend && this.hooks.onSend(this.chatList);
      // 滚动到最底部
      this.$refs.chatScroll.scrollBottom();
    },
    async onStop() {
      const index = this.chatList.findIndex(item =>
        [0, 1].includes(item.status),
      );
      if (index === -1) return;
      await Http.post('/chatvisa_record_stop', {
        chatvisa_record_id: this.chatList[index].chatvisa_record_id,
      });
      this.updateChatItemInfo(
        {
          status: 3,
        },
        index,
      );
    },
    updateChatItemInfo(obj, index) {
      Object.assign(this.chatList[index], obj);
    },
    // 引导模块触发发送问题
    onSendQuestion(question) {
      this.onSend(question);
    },
    // 滚动到最底部
    goScrollBottom() {
      this.$refs.chatScroll.scrollBottom(true);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable.less";

.chat-visa-page {
  width: 100%;
  height: 100%;
  background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/page-bg.png) #fff
    no-repeat center center / 100% 100%;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 1.5;
  color: #2f333d;
  &.small {
    // 小尺寸
    font-size: 14px;

    .question-input-box {
      box-shadow: none !important;
      border: 1px solid #e9eef2;
      background: #fff;
    }
  }
  .page-scroll-box {
    flex-grow: 1;
    overflow: hidden;
    .page-body {
      padding: 30px 0;
      margin: 0 auto;
    }
    .show-more {
      cursor: pointer;
      text-align: center;
      color: @new-blue;
      display: flex;
      align-items: center;
      justify-content: center;
      .more-text {
        position: relative;
        font-size: 14px;
        &.small {
          font-size: 12px;
        }
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 100%;
          margin-right: 12px;
          width: 118px;
          height: 1px;
          background: #c9cdd1;
          border-radius: 1px;
        }
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 100%;
          margin-left: 12px;
          width: 120px;
          height: 1px;
          background: #c9cdd1;
        }
      }
    }
  }
  .footer-box {
    flex-shrink: 0;
    padding: 11px 0 20px 0;
    .footer-body {
      margin: 0 auto;
    }
    .quick-handler {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 9px;
      height: 38px;
      .left-box {
        display: flex;
        align-items: center;
        gap: 12px;
        /deep/ .handler-btn {
          height: 32px;
          background: rgba(255, 255, 255, 0.5);
          box-shadow: 0px 3px 16px 0px rgba(30, 43, 61, 0.2);
          border-radius: 8px;
          border: 1px solid #ffffff;
          backdrop-filter: blur(10px);
          padding: 0 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #2f333d;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .right-box {
        display: flex;
        align-items: center;
        gap: 12px;
        .back-bottom {
          width: 38px;
          height: 38px;
          background: #ffffff;
          box-shadow: 0px 3px 16px 0px rgba(30, 43, 61, 0.2);
          border-radius: 50%;
          border: 1px solid #c9cdd1;
          backdrop-filter: blur(10px);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .icon {
            background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/icon-back-bottom.png)
              #fff no-repeat center center / 100% 100%;
            width: 14px;
            height: 20px;
            cursor: pointer;
          }
        }
      }
    }
    .question-input-box {
      width: 100%;
      position: relative;
      box-shadow: 0px 3px 16px 0px rgba(30, 43, 61, 0.12);
      border-radius: 8px;
      overflow: hidden;
      padding: 1px;
      &.focus {
        &::after {
          content: "";
          position: absolute;
          left: 0px;
          right: 0px;
          top: 0px;
          bottom: 0px;
          z-index: 1;
          border-radius: 8px;
          background: linear-gradient(to right, #6facff, #8765ff);
        }
      }
      .login-mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        z-index: 10;
      }
      .question-input-body {
        display: flex;
        flex-direction: column;
        width: 100%;
        z-index: 3;
        padding: 16px;
        background: #fff;
        border-radius: 8px;
        // max-height: 88px;
        position: relative;
        &.small {
          padding: 12px;
          background: #fff;
          // border-radius: 4px;
        }
      }
      .input-bottom {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        align-items: center;
        .question-num {
          font-size: 14px;
          color: #91999f;
          &.is-red {
            color: #f66878;
          }
        }
        .handle-btn {
          &.small {
            right: 12px;
            bottom: 12px;
            .item-btn {
              width: 36px;
              height: 20px;
              border-radius: 1.5px;
              .icon {
                width: 16px;
                height: 16px;
                &.send {
                  background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/btn-send-small.png)
                    no-repeat center center / 100% 100%;
                }
                &.stop {
                  background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/btn-stop-small.png)
                    no-repeat center center / 100% 100%;
                }
              }
            }
          }
          .item-btn {
            border: none;
            outline: none;
            width: 48px;
            height: 32px;
            background: linear-gradient(224deg, #8765ff 0%, #6facff 100%);
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &[disabled] {
              opacity: 0.3;
              cursor: not-allowed;
            }
            .icon {
              width: 24px;
              height: 24px;
              &.send {
                background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/btn-send.png)
                  no-repeat center center / 100% 100%;
              }
              &.stop {
                background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/btn-stop.png)
                  no-repeat center center / 100% 100%;
              }
            }
          }
        }
      }
    }
    .tips {
      color: #91999f;
      margin-top: 12px;
      text-align: center;
      font-size: 12px;
      line-height: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/components/chat-visa-component.vue